import { createFileRoute } from '@tanstack/react-router';
import { isOperator } from '../../app/roles.ts';
import { PAGE, PageHeader } from '../../app/shell.tsx';
import { useMe } from '../../app/use-me.ts';
import { UsersView } from '../../features/admin/users.tsx';

export const Route = createFileRoute('/_app/users')({ component: UsersPage });

function UsersPage() {
  const me = useMe();
  return (
    <>
      <PageHeader
        title="Users"
        eyebrow="Admin"
        description="People who can sign in, their roles and what those roles allow. Changes are audited."
      />
      <div className={PAGE}>
        {isOperator(me) ? (
          <UsersView canGrantAdmin={me.roles.includes('admin')} selfId={me.id} />
        ) : (
          <p className="text-ink-2">Only operators manage users.</p>
        )}
      </div>
    </>
  );
}
